import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import PersonCounter from "../../../../../../others/person-counter/index.js";
import usePassengersRow from "../../hook/usePassengersRow.js";
const PassengersMobileRow = (props)=>{
    const { passenger , label ='' , info , description ='' , labelForEachOption ='' , disableIncrement , onChange , onSelectChange  } = props;
    const { selectedOptions  } = usePassengersRow(props);
    const select = useMemo(()=>({
            label: passenger.optionsLabel,
            options: passenger.options,
            onChange: onSelectChange
        }), [
        onSelectChange,
        passenger.options,
        passenger.optionsLabel
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "PassengersRow",
        className: "passanger-row-mobile",
        children: /*#__PURE__*/ _jsx(PersonCounter, {
            label: label,
            description: description || passenger.description,
            info: info,
            min: passenger.min,
            max: passenger.max,
            tooltip: passenger.tooltip,
            value: passenger.value,
            onChange: onChange,
            labelForEachOption: labelForEachOption,
            selectedOptions: selectedOptions,
            select: select,
            disableIncrement: disableIncrement
        })
    });
};
export default PassengersMobileRow;

//# sourceMappingURL=index.js.map